module.exports = __webpack_public_path__ + "img/CoverImage.14244f03.svg";